import { render, staticRenderFns } from "./SpecificDiscount.vue?vue&type=template&id=a1fe63a4&"
import script from "./SpecificDiscount.vue?vue&type=script&lang=ts&"
export * from "./SpecificDiscount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports